import React from 'react';
import './CompetitionArtwork.css';

/** Quiet, decorative chart for the homepage hero. */
const CompetitionArtwork: React.FC = () => (
  <div className="competition-artwork" aria-hidden="true">
    <svg className="competition-artwork__chart" viewBox="0 20 410 260" fill="none" focusable="false">
      <path
        className="competition-artwork__axis"
        vectorEffect="non-scaling-stroke"
        d="M18 36V254H394"
      />
      <path
        className="competition-artwork__ticks"
        vectorEffect="non-scaling-stroke"
        d="M13 52H18M13 100H18M13 148H18M13 196H18M90 254V259M162 254V259M234 254V259M306 254V259M378 254V259"
      />
      <path
        className="competition-artwork__comparison"
        vectorEffect="non-scaling-stroke"
        d="M24 236C48 235 58 222 78 224S110 202 130 208S154 220 174 205S198 185 218 190S244 199 266 180S298 166 318 172S350 157 386 144"
      />
      <path
        className="competition-artwork__line"
        vectorEffect="non-scaling-stroke"
        d="M24 224C46 223 58 211 78 212S108 231 126 210S149 173 168 178S194 194 211 172S235 128 252 134S279 159 298 129S329 86 346 78S372 67 386 47"
      />
    </svg>
  </div>
);

export default CompetitionArtwork;
